import React from "react";
import Column from "@amzn/meridian/column";
import SBLDashboardContextProvider from "../ledcontroller/context/SBLDashboardContext";
import {NavigationRoutes} from "../../util/TabLayout";
import {LED_CONTROLLER_STAG_ROUTES} from "../../util/RouteConstants";

const LEDControllerSTAGPage = () => (
    <Column>
        <SBLDashboardContextProvider>
            <NavigationRoutes routes={LED_CONTROLLER_STAG_ROUTES}/>
        </SBLDashboardContextProvider>
    </Column>
);

export default LEDControllerSTAGPage;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontrollerstag/LEDControllerSTAGPage.js